/* DILI Diwali: lazy cart status + gift selection. Backend discount must be configured in Shopify. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const offerId = 'DiliDiwaliOffer';
  const $ = (s, node = document) => node.querySelector(s);
  const offer = () => document.getElementById(offerId);
  let timer = null, updating = false, lastSignature = '', pickerHTML = '', locking = false, previousFocus = null;
  const status = (text) => { const el = $('[data-dili-gift-status]'); if (el) el.textContent = text; };
  const json = async (path, options = {}) => {
    const response = await fetch(`${root}${path}`, { credentials:'same-origin', cache:'no-store', ...options });
    const result = await response.json();
    if (!response.ok || result?.status >= 400) throw new Error(result?.description || result?.message || 'Unable to update bag.');
    return result;
  };
  const postCart = (path, body) => json(path, { method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body) });
  const giftActive = () => Boolean(offer()?.dataset.giftKey);
  const giftPending = () => giftActive() && offer()?.dataset.giftFree !== 'true';
  window.DiliDiwali = { giftActive, giftPending, active: giftActive, refresh: () => scheduleRefresh(120) };

  const setVisibility = () => {
    const box = offer();
    const hasGift = Boolean(box?.dataset.giftKey);
    const eligible = box?.dataset.pairReady === 'true';
    document.body.classList.toggle('dili-diwali-gift-active', hasGift);
    document.querySelectorAll('[data-dili-gift-credit-note]').forEach(el => { el.hidden = !hasGift; });
    const wallet = document.querySelector('[data-dili-wallet]');
    if (wallet) {
      for (const control of wallet.querySelectorAll('[data-dili-credit-input], [data-dili-credit-apply], [data-dili-credit-max]')) {
        control.disabled = hasGift;
      }
    }
    const chip = box && $('[data-dili-gift-open]', box);
    if (chip) chip.hidden = !eligible && !hasGift;

    // A visible action INSIDE the cart, independent of the automatic modal.
    document.querySelectorAll('[data-dili-gift-inline]').forEach((banner) => {
      banner.hidden = !box;
      if (!box) return;
      const copy = $('[data-dili-gift-inline-status]', banner);
      const button = $('[data-dili-gift-open]', banner);
      const count = Number(box.dataset.eligibleCount || 0);
      const missing = Number(box.dataset.shortfallPaise || 0);
      const formatted = new Intl.NumberFormat('en-IN', {style:'currency', currency:'INR', minimumFractionDigits:0, maximumFractionDigits:2}).format(missing/100);
      if (copy) copy.textContent = hasGift
        ? (box.dataset.giftFree === 'true'
          ? 'Your selected regular tee is FREE in the cart. Enjoy your Diwali gift.'
          : 'We couldn’t apply the Diwali gift to your order. Remove the tee to continue checkout.')
        : eligible
          ? 'Your cart qualifies. Pick any available regular tee and size.'
          : count < 2
            ? 'Add at least two qualifying articles (regular T-shirts do not count).'
            : `Add ${formatted} more in qualifying products to unlock your regular tee.`;
      if (button) {button.hidden = !eligible && !hasGift;button.textContent = hasGift ? 'View / change tee' : 'Choose regular tee';}
      banner.classList.toggle('dili-gift-inline--pending', hasGift && box.dataset.giftFree !== 'true');
    });
  };
  function closeModal() {
    const modal = $('[data-dili-gift-modal]', offer());
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('dili-diwali-modal-open');
    previousFocus?.focus?.({ preventScroll:true });
  }
  async function loadPicker() {
    if (pickerHTML) return pickerHTML;
    const fallback = () => {
      const template = $('[data-dili-gift-fallback]', offer());
      return template?.content?.querySelector('.dili-gift-card') ? template.innerHTML : '';
    };
    try {
      const response = await fetch(`${root}?section_id=dili-diwali-picker`, { cache:'no-store', credentials:'same-origin' });
      if (!response.ok) throw new Error('Cannot retrieve the tee collection.');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html,'text/html');
      const grid = $('[data-dili-gift-picker]',doc);
      if (!grid || !$('.dili-gift-card',grid)) throw new Error('The standalone tee selector is unavailable.');
      pickerHTML = grid.innerHTML;
    } catch (error) {
      // Never show an empty modal because an uninstantiated Shopify section failed.
      pickerHTML = fallback();
      if (!pickerHTML) throw error;
    }
    return pickerHTML;
  }
  async function openModal() {
    const box = offer();
    if (!box || (box.dataset.pairReady !== 'true' && !box.dataset.giftKey)) return;
    previousFocus = document.activeElement;
    const modal = $('[data-dili-gift-modal]',box);
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('dili-diwali-modal-open');
    $('[data-dili-gift-close]',modal)?.focus({preventScroll:true});
    const list = $('[data-dili-gift-list]',modal);
    if (box.dataset.giftKey) {
      const confirmed = box.dataset.giftFree === 'true';
      list.innerHTML = `<div class="dili-gift-selected"><p>${confirmed
        ? 'Your selected DILI tee is in the cart at ₹0.'
        : 'Your tee is selected, but the Diwali offer could not be applied. Remove your selection to continue checkout.'}</p><button type="button" data-dili-gift-remove>Change my free tee</button></div>`;
      return;
    }
    try { list.innerHTML = await loadPicker(); }
    catch (error) { status(error.message); list.innerHTML = '<p>Unable to load choices. Please reload the page.</p>'; }
  }
  const signature = (data) => `${data?.eligibleCount || '0'}:${data?.pairAmount || '0'}:${data?.pairReady || 'false'}:${data?.giftKey || ''}`;
  async function sync({autoOpen = true}={}) {
    if (updating) return;
    updating = true;
    try {
      const result = await fetch(`${root}cart?section_id=dili-diwali-offer`, { credentials:'same-origin', cache:'no-store' });
      if (!result.ok) return;
      const html = await result.text();
      const doc = new DOMParser().parseFromString(html,'text/html');
      const next = $('#DiliDiwaliOffer',doc);
      const current = offer();
      if (!next) {
        if (current) { closeModal();current.remove(); }
        document.body.classList.remove('dili-diwali-gift-active');
        return;
      }
      // Only remove an actually INELIGIBLE gift or clamp its quantity.
      // IMPORTANT: no longer delete a valid selected tee solely because its Shopify
      // checkout discount is pending. That was the v6 add-then-delete bug.
      const requestedGiftQty = Number(next.dataset.giftQty || 0);
      if (next.dataset.giftKey && (next.dataset.pairReady !== 'true' || requestedGiftQty > 1)) {
        await postCart('cart/change.js', { id: next.dataset.giftKey, quantity: next.dataset.pairReady !== 'true' ? 0 : 1 });
        if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
        else scheduleRefresh(180);
        return;
      }
      const now = signature(next.dataset);
      if (current && now !== signature(current.dataset)) {closeModal(); current.replaceWith(next);}
      else if (!current) document.body.appendChild(next);
      setVisibility();
      if (autoOpen && next.dataset.pairReady === 'true' && !next.dataset.giftKey) {
        const seenKey = `dili-diwali-seen:${now}`;
        try { if (!sessionStorage.getItem(seenKey)) {sessionStorage.setItem(seenKey,'yes'); openModal();} }
        catch (_) { if (now !== lastSignature) openModal(); }
      }
      lastSignature = now;
    } catch (error) { console.warn('[DILI festive] Gift status:',error); }
    finally {updating = false;}
  }
  function scheduleRefresh(delay = 250) { window.clearTimeout(timer);timer=window.setTimeout(() => sync(), delay); }

  // Keep the working v8 native Shopify product form. A stored wallet balance must
  // NEVER block gift selection. Only a previously APPLIED cart credit/code needs
  // to be detached from this order, without changing the wallet account itself.
  const stored = (key) => { try { return localStorage.getItem(key) || ''; } catch (_) { return ''; } };
  const forget = (key) => { try { localStorage.removeItem(key); } catch (_) {} };
  async function suspendOldCartDiscounts() {
    if (window.DiliCreditCart?.suspendRedemptionsForGift) {
      return window.DiliCreditCart.suspendRedemptionsForGift();
    }
    // Cart extras is not loaded on every template. Use the documented Shopify
    // cart discount API here as a fallback, without deleting any wallet credits.
    const hasCredit = Boolean(stored('dili-credit-code'));
    if (!hasCredit && !stored('dili-selected-coupon')) return;
    await postCart('cart/update.js', { discount: '' });
    forget('dili-selected-coupon');
    if (hasCredit) {
      try {
        const result = await fetch('https://my.diliclothing.com/api/cart-credit-remove.php', {
          method:'POST', credentials:'include', mode:'cors', cache:'no-store',
          headers:{ Accept:'application/json', 'Content-Type':'application/json' }, body:'{}'
        });
        if (!result.ok) throw new Error('The wallet reservation could not be released.');
        forget('dili-credit-release-pending');
      } catch (_) {
        try { localStorage.setItem('dili-credit-release-pending','1'); } catch (_) {}
      }
      forget('dili-credit-code'); forget('dili-credit-amount');
    }
  }
  async function confirmGiftForm(event) {
    const form = event.target;
    if (!form?.matches?.('.dili-gift-native-form')) return;
    const box = offer();
    const chosen = form.querySelector('[name="id"]');
    if (!box || box.dataset.pairReady !== 'true' || box.dataset.giftKey) {
      event.preventDefault();
      status('Your cart has changed. Please refresh the cart to choose your free tee.');
      return;
    }
    if (!chosen || !/^\d+$/.test(String(chosen.value || '')) || chosen.selectedOptions?.[0]?.disabled) {
      event.preventDefault();
      status('Please choose an available T-shirt size.');
      return;
    }
    const button = form.querySelector('[type="submit"]');
    if (form.dataset.diliGiftSubmitting === '1') {event.preventDefault();return;}
    // No applied cart redemption? Let v8's reliable native form submit normally.
    if (!stored('dili-credit-code') && !stored('dili-selected-coupon') && !document.querySelector('[data-dili-wallet][data-dili-reserved-code]:not([data-dili-reserved-code=""])')) {
      if (button) button.textContent = 'Adding to cart…';
      return;
    }
    event.preventDefault();
    form.dataset.diliGiftSubmitting = '1';
    if (button) { button.disabled = true; button.textContent = 'Preparing your gift…'; }
    status('Preparing your Diwali gift. Your DILI Credits will stay in your wallet.');
    try {
      await suspendOldCartDiscounts();
      if (button) button.textContent = 'Adding to cart…';
      // Native HTML form submission preserves v8's selected variant, gift markers,
      // and redirect. This avoids the AJAX cart-add regression in older versions.
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      delete form.dataset.diliGiftSubmitting;
      if (button) { button.disabled = false; button.textContent = 'Select free tee'; }
      status('We couldn’t prepare this offer. Please try again. Your DILI Credits remain in your wallet.');
    }
  }
  document.addEventListener('submit', confirmGiftForm);

  async function removeGift() {
    const key = offer()?.dataset.giftKey;
    if (!key || locking) return;
    locking = true;
    status('Removing the selected tee…');
    try {
      await postCart('cart/change.js', {id:key, quantity:0});
      window.location.assign(`${root}cart`);
    } catch (error) {
      status(error.message || 'Could not remove the tee. Please try again.');
      locking = false;
    }
  }
  // Prevent checkout with a FULL-PRICE gift line. Prices must come from
  // Shopify's actual discount, never from a cosmetic front-end price override.
  function preventUnpricedGiftCheckout(event) {
    if (!giftPending()) return false;
    const target = event.target;
    const button = target.closest?.('[name="checkout"], [data-dili-credit-checkout], .cart__checkout-button, .cart-drawer__checkout, [data-shopify="payment-button"]');
    if (!button && event.type === 'click') return false;
    if (event.type === 'submit') {
      const form = target;
      if (form?.matches?.('.dili-gift-native-form')) return false;
      if (form?.id !== 'cart' && !form?.matches?.('form[action*="/cart"]')) return false;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    const notice = document.querySelector('[data-dili-gift-checkout-warning]');
    if (notice) { notice.hidden = false; notice.scrollIntoView({behavior:'smooth',block:'center'}); }
    else window.alert('We couldn’t apply the Diwali offer. Remove your selected gift to continue checkout.');
    return true;
  }
  document.addEventListener('submit', preventUnpricedGiftCheckout, true);
  document.addEventListener('click', preventUnpricedGiftCheckout, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-dili-gift-remove]')) {event.preventDefault();removeGift();return;}
    if (event.target.closest('[data-dili-gift-open]')) {event.preventDefault(); openModal();return;}
    if (event.target.closest('[data-dili-gift-close]')) {event.preventDefault();closeModal();return;}
    if (event.target.matches('[data-dili-gift-modal]')) {closeModal();return;}
    // Native product forms handle Select Free Tee; no click interception.
    // A normal form POST sends size, quantity and gift properties to Shopify.
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { closeModal();return;}
    const modal = $('[data-dili-gift-modal]',offer());
    if (event.key !== 'Tab' || !modal || modal.hidden) return;
    const focusables = [...modal.querySelectorAll('a[href],button:not([disabled]),select:not([disabled]),input:not([disabled])')].filter(el => el.getClientRects().length);
    if (!focusables.length) return;
    const first = focusables[0], last = focusables[focusables.length-1];
    if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
  });
  function initialize() {
    setVisibility();
    const box = offer();
    if (box && box.dataset.pairReady === 'true' && !box.dataset.giftKey) {
      const key=`dili-diwali-seen:${signature(box.dataset)}`;
      try {if (!sessionStorage.getItem(key)) {sessionStorage.setItem(key,'yes');openModal();}} catch (_) {}
    }
    // Pub/sub used by native Dawn cart updates.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => scheduleRefresh(180));
    if (box?.dataset.giftKey) scheduleRefresh(250);

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  // With the campaign disabled, the passive scroll ornament is the only active feature.
  // Do not wrap fetch or add cart network work until gift promotion is configured and on.
  if (!offer()) return;
  // Custom DILI product modules may not publish Dawn's cart events. Refresh only when an actual cart mutation succeeds.
  const originalFetch=window.fetch;
  window.fetch=function(...args) {
    const result=originalFetch.apply(this,args);
    try {
      const req = args[0];const url = typeof req === 'string' ? req : req?.url || '';
      const method = String(args[1]?.method || req?.method || 'GET').toUpperCase();
      if (method !== 'GET' && /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) {
        result.then(res => {if (res.ok && !locking) scheduleRefresh(350);}).catch(() => {});
      }
    } catch (_) {}
    return result;
  };
})();
